export default {
  INITIALEIZED: "INITIALEIZED",
  CREATE_OTP_PENDING: "CREATE_OTP_PENDING",
  CREATE_OTP_SUCCESS: "CREATE_OTP_SUCCESS",
  CREATE_OTP_FAIL: "CREATE_OTP_FAIL",
  VALIDATE_OTP_PENDING: "VALIDATE_OTP_PENDING",
  VALIDATE_OTP_SUCCESS: "VALIDATE_OTP_SUCCESS",
  VALIDATE_OTP_FAIL: "VALIDATE_OTP_FAIL",
  RESET: "RESET",
}